export const candleNumberProcessor = (prevCandle, candle) => {
  if(!prevCandle || !candle) return 0;
  if(candle?.low < prevCandle?.low && candle?.high > prevCandle?.high) return 3;
  else if(candle?.low < prevCandle?.low || candle?.high > prevCandle?.high) return 2;
  else return 1;
}